import type { FC } from "react"

import { useRecoilValue } from "recoil"

import { ErrorBoundary } from "~/components/ErrorBoundary"

import ActiveSnapPoint from "./ActiveSnapPoint"
import { AutoPlacementVisualization } from "./AutoPlacementVisualization"
import { DivisionVisualization } from "./DivisionVisualization"
import { InsetAreaFilteringVisualizations } from "./InsetAreaFilteringVisualizations"
import { LinkedEdgesVisualizations } from "./LinkedEdgesVisualizations"
import PanelSelectionOutline from "./PanelSelectionOutline"
import SelectionSnapPoints from "./SelectionSnapPoints"
import { TracingVisualization } from "./TracingVisualization"
import UnselectedSnapPoints from "./UnselectedSnapPoints"
import { EdgeLabels } from "../Labels/EdgeLabels"
import NodeLabels from "../Labels/NodeLabels"
import PanelLabels from "../Labels/PanelLabels"
import { debugOrderState, debugVisualizationsEnabledState } from "../state"

const DebugVisualizationComponents: {
  [key: string]: FC
} = {
  SelectionSnapPoints,
  UnselectedSnapPoints,
  ActiveSnapPoint,
  NodeLabels,
  PanelLabels,
  PanelSelectionOutline,
  AutoPlacementVisualization,
  TracingVisualization,
  InsetAreaFilteringVisualizations,
  LinkedEdgesVisualizations,
  EdgeLabels,
  DivisionVisualization,
}

export const StudioDebugVisualization: FC = () => {
  const debugVisualizationsEnabled = useRecoilValue(
    debugVisualizationsEnabledState,
  )
  const debugTools = useRecoilValue(debugOrderState)

  return (
    <ErrorBoundary
      Fallback={({ error }) => (
        <g>
          <text>DebugTools broke:</text>
          <text>{error?.toString()}</text>
        </g>
      )}
    >
      <g style={{ pointerEvents: `none` }}>
        {debugTools
          .filter((name) => debugVisualizationsEnabled.has(name))
          .reverse()
          .map((name) => {
            const Component = DebugVisualizationComponents[name]

            return (
              <ErrorBoundary key={name + `Component`}>
                <Component />
              </ErrorBoundary>
            )
          })}
      </g>
    </ErrorBoundary>
  )
}
